import React, { useContext } from "react";
import style from "./index.module.scss";
import qs from "qs";
import { useHistory } from "react-router-dom";
import { CourseContext } from "../../../Store";

interface ListStaticsProps {
    questionId: number;
    allCount: number;
    joinCount: number;
    noJoinCount: number;
}

export default function ListStatics({
    questionId,
    allCount,
    joinCount,
    noJoinCount
}: ListStaticsProps) {
    const history = useHistory();
    const { basename } = useContext(CourseContext);
    function gotoDetail(questionId: number, params?: StringMap) {
        const query = params ? `?${qs.stringify(params)}` : "";
        history.push(`${basename}/question/students/${questionId}${query}`);
    }

    return (
        <div className={style.root}>
            <div
                className={style.item}
                onClick={() => gotoDetail(questionId, { status: "all" })}>
                {allCount}
                <br />
                <span>课程人数</span>
            </div>
            <div
                className={style.item}
                onClick={() => gotoDetail(questionId, { status: "joinCount" })}>
                {joinCount}
                <br />
                <span>已参与</span>
            </div>
            <div
                className={style.item}
                onClick={() =>
                    gotoDetail(questionId, { status: "noJoinCount" })
                }>
                {noJoinCount}
                <br />
                <span>未参与</span>
            </div>
        </div>
    );
}

ListStatics.defaultProps = {
    exerciseAllCount: 0,
    noJudgeCount: 0,
    judgeCount: 0,
    noJoinInExerciseCount: 0
};
